import React, { useState, useEffect } from "react";
import { Box, Paper, Typography, Dialog, DialogContent } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  LogOut,
  // Key,
  Mail,
  Globe,
  // Bell,
  ChevronRight,
  Phone,
  Calendar,
  Key,
} from "lucide-react";
import { logout } from "../../api/login/authService";
import logoutImg from "../../assets/img/logout.png";
import { User } from "../../types/user";
import { useTranslation } from "react-i18next";

const ProfilePage: React.FC = () => {
  const { t } = useTranslation();

  const settings = [
    {
      icon: <Key size={20} />,
      label: t("button.changePassword"),
      route: "/profile/change-password",
    },
    // { icon: <Mail size={20} />, label: "Change E-mail", route: "#" },
    {
      icon: <Globe size={20} />,
      label: t("title.language"),
      route: "/profile/language",
    },
    // { icon: <Bell size={20} />, label: "Notification Settings", route: "#" },
  ];
  const navigate = useNavigate();
  const [logoutModalOpen, setLogoutModalOpen] = useState(false);
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    const profileData = localStorage.getItem("profile");
    if (profileData) {
      try {
        const parsedProfile = JSON.parse(profileData);
        setUser(parsedProfile);
      } catch (error) {
        console.error("Error parsing profile data from localStorage", error);
      }
    }
  }, []);

  const openLogoutModal = () => {
    setLogoutModalOpen(true);
  };

  const closeLogoutModal = () => {
    setLogoutModalOpen(false);
  };

  const handleLogout = async () => {
    await logout();
    closeLogoutModal();
    navigate("/login");
  };

  return (
    <Box className="flex flex-col ">
      {/* Main Content */}
      <Box className="flex-1 pt-2 px-2 mx-auto w-full sm:max-w-md md:max-w-xl lg:max-w-2xl xl:max-w-4xl">
        <Paper
          elevation={1}
          className="w-full rounded-2xl p-4 md:p-8 bg-white h-[75vh] md:h-[80vh] flex flex-col"
          sx={{ borderRadius: { xs: "24px", md: "16px" } }}
        >
          {/* User Info */}
          <div className="mb-10">
            <Typography
              variant="h5"
              className="font-bold text-xl md:text-2xl lg:text-3xl mb-6 text-gray-900"
            >
              {user ? `${user.firstName} ${user.lastName}` : "Loading..."}
            </Typography>

            <div className="flex items-center text-gray-700 text-sm md:text-base mb-4 mt-2">
              <Calendar size={18} className="mr-3 text-orange-500" />
              {user?.dob || ""}
            </div>
            <div className="flex items-center text-gray-700 text-sm md:text-base mb-4">
              <Phone size={18} className="mr-3 text-orange-500" />
              {user?.phoneNumber || ""}
            </div>
            <div className="flex items-center text-gray-700 text-sm md:text-base">
              <Mail size={18} className="mr-3 text-orange-500" />
              {user?.email || ""}
            </div>
          </div>
          <div className="rounded border border-gray-200 mb-3"></div>

          <Typography
            variant="subtitle1"
            className="mb-5 font-semibold text-gray-800 text-lg md:text-xl"
          >
            {t("title.settings")}
          </Typography>

          {/* Settings List */}
          <div className="flex flex-col gap-3 mb-6">
            {settings.map((item, idx) => (
              <button
                key={idx}
                onClick={() => navigate(item.route)}
                className="flex items-center justify-between w-full px-5 py-4 rounded-xl hover:bg-orange-100 transition shadow-md"
              >
                <span className="flex items-center gap-3 text-gray-800 font-medium text-base md:text-lg">
                  <span className="text-gray-900">{item.icon}</span>

                  {item.label}
                </span>
                <ChevronRight size={20} className="text-gray-400" />
              </button>
            ))}
          </div>
          <div className="mt-auto flex-grow"></div>
          <div className="rounded border border-gray-200 mb-6"></div>
          {/* Logout Button */}
          <button
            onClick={openLogoutModal}
            className="w-full px-5 py-4 rounded-xl bg-white border border-gray-100 shadow-md flex items-center justify-center gap-3 text-orange-600 font-semibold text-base md:text-lg hover:bg-orange-50 transition"
          >
            <LogOut size={22} /> {t("title.logOut")}
          </button>

          {/* Logout Confirmation Modal */}
          <Dialog
            open={logoutModalOpen}
            onClose={closeLogoutModal}
            PaperProps={{
              style: {
                borderRadius: "16px",
                maxWidth: "360px",
                width: "100%",
                padding: "16px",
              },
            }}
          >
            <DialogContent className="p-5">
              <div className="flex flex-col items-center">
                <div className="flex justify-center items-center w-12 h-12 rounded-full bg-orange-100 mb-4">
                  <img src={logoutImg} alt="Logout" width={48} height={48} />
                </div>
                <Typography variant="h6" className="font-bold text-center mb-1">
                  {t("title.logOut")}
                </Typography>
                <Typography
                  variant="body2"
                  className="text-gray-500 text-center mb-6"
                >
                  {t("title.logOutTitle")}
                </Typography>
                <div className="flex w-full gap-3 mt-2">
                  <button
                    onClick={handleLogout}
                    className="flex-1 py-2.5 px-4 rounded-lg border border-gray-300 text-gray-700 font-medium"
                  >
                    {t("title.logOut")}
                  </button>
                  <button
                    onClick={closeLogoutModal}
                    className="flex-1 py-2.5 px-4 rounded-lg bg-orange-500 text-white font-medium"
                  >
                    {t("button.cancel")}
                  </button>
                </div>
              </div>
            </DialogContent>
          </Dialog>
        </Paper>
      </Box>
    </Box>
  );
};

export default ProfilePage;
